import { findFaultData } from "../../api/config/modules/FaultManagement";

const state = {
    findFaultData: {},
};

const mutations = {
  SET_FINDFAULTDATA: (state, findFaultData) => {
    state.findFaultData = findFaultData;
  },
};

const actions = {
  GET_FINDFAULTDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        findFaultData(data).then((res) => {
          commit("SET_FINDFAULTDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
